// extracted by mini-css-extract-plugin
export default {"AssignChecklist":"StaffClientsModal_AssignChecklist__fPMc3","modalBody":"StaffClientsModal_modalBody__hkxK-","formControl":"StaffClientsModal_formControl__r9WDG"};